import React from 'react';
import { motion } from 'framer-motion';

const Loader = ({ fullScreen = false }) => {
  const containerClasses = fullScreen
    ? "fixed inset-0 z-50 flex flex-col items-center justify-center bg-white/60 backdrop-blur-md"
    : "flex flex-col items-center justify-center w-full py-24 min-h-[350px]";

  return (
    <div className={containerClasses}>
      <div className="relative flex items-center justify-center w-24 h-24 mb-8">

        {/* Ambient Glow */}
        <div className="absolute inset-0 bg-brand-primary/20 blur-2xl rounded-full animate-pulse mix-blend-multiply"></div>

        {/* Outer subtle ring */}
        <div className="absolute inset-0 rounded-full border-[4px] border-gray-100"></div>

        {/* Animated Gradient Spinner */}
        <svg viewBox="0 0 100 100" className="w-full h-full absolute inset-0 -rotate-90">
          <defs>
            <linearGradient id="spinner-gradient" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stopColor="#38bdf8" />
              <stop offset="50%" stopColor="#1d86ca" />
              <stop offset="100%" stopColor="#1e3a8a" />
            </linearGradient>
            <filter id="glow-spinner">
              <feGaussianBlur stdDeviation="4" result="coloredBlur" />
              <feMerge>
                <feMergeNode in="coloredBlur" />
                <feMergeNode in="SourceGraphic" />
              </feMerge>
            </filter>
          </defs>
          <motion.circle
            cx="50"
            cy="50"
            r="44"
            fill="none"
            stroke="url(#spinner-gradient)"
            strokeWidth="8"
            strokeLinecap="round"
            filter="url(#glow-spinner)"
            initial={{ strokeDasharray: "0 280", strokeDashoffset: 0 }}
            animate={{
              strokeDasharray: ["0 280", "140 280", "280 280"],
              strokeDashoffset: [0, -70, -280]
            }}
            transition={{
              duration: 2,
              ease: "easeInOut",
              repeat: Infinity,
            }}
          />
        </svg>

        {/* Inner pulsing core */}
        <motion.div
          animate={{ scale: [0.8, 1.2, 0.8], opacity: [0.5, 1, 0.5] }}
          transition={{ duration: 2, repeat: Infinity, ease: "easeInOut" }}
          className="absolute w-4 h-4 bg-brand-light rounded-full shadow-[0_0_15px_rgba(29,134,202,0.8)]"
        />
      </div>

      <motion.div
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5, delay: 0.2 }}
        className="flex flex-col items-center"
      >
        {/* <span className="text-sm font-semibold tracking-[0.2em] text-gray-400 uppercase">
          Loading Data
        </span> */}
        <div className="flex gap-1 mt-2">
          <motion.div animate={{ scale: [1, 1.5, 1], opacity: [0.3, 1, 0.3] }} transition={{ duration: 1, repeat: Infinity, delay: 0 }} className="w-1.5 h-1.5 rounded-full bg-brand-primary"></motion.div>
          <motion.div animate={{ scale: [1, 1.5, 1], opacity: [0.3, 1, 0.3] }} transition={{ duration: 1, repeat: Infinity, delay: 0.2 }} className="w-1.5 h-1.5 rounded-full bg-brand-primary"></motion.div>
          <motion.div animate={{ scale: [1, 1.5, 1], opacity: [0.3, 1, 0.3] }} transition={{ duration: 1, repeat: Infinity, delay: 0.4 }} className="w-1.5 h-1.5 rounded-full bg-brand-primary"></motion.div>
        </div>
      </motion.div>
    </div>
  );
};

export default Loader;
